<template>
  <L1Vue>
    <template slot="slot_title">
      <Select1 :width="'200px'" :defaultValue="time" @input="time=$event">
        <option value="進行中">進行中</option>
        <option value="即將開始">即將開始</option>
        <option value="已結束">已結束</option>
        <option value="未啟動">未啟動</option>
      </Select1>
      <Select1 :width="'260px'" :defaultValue="store" @input="store=$event">
        <option :value="null">請選擇商店</option>
        <option v-for="(store, s) in stores" :key="`store-${s}`" :value="store">{{store}}</option>
      </Select1>
      <Select1 :width="'260px'" :defaultValue="partner" @input="partner=$event">
        <option :value="null">請選擇夥伴</option>
        <option v-for="(store, s) in partners" :key="`partner-${s}`" :value="store._id">{{store.name}}</option>
      </Select1>
      <div :style="{marginInline: 'auto'}"></div>
      <RoundBtn :icon="'add'" :text="'新增活動'" :bg="'var(--color-pri)'" @click="addnew=true"/>
    </template>
    <div class="cubeProjects">
      <CubeProject v-for="(project, p) in projects" :key="`project-${p}`" :item="project" :color="project.partner?.color"
      @select="$router.push({name: 'restProjectSingle', params: {id: project._id}, query: {page: '基本設定'}})"/>
    </div>
    <AddNewVue v-if="addnew" @close="addnew=false" @update="getProjects"/>
  </L1Vue>
</template>

<script>
import AddNewVue from './setting/new.vue'
import RoundBtn from '../../components/btn/round.vue'
import CubeProject from './cube.vue'
import L1Vue from '../../components/layout/L1.vue'
import { getapi } from '../../store/fetch'
import { mapState } from 'vuex'
export default {
  components: { L1Vue, CubeProject, RoundBtn, AddNewVue },
  data () {
    return {
      projects: [],
      time: '進行中',
      store: null,
      partner: null,
      partners: [],
      addnew: false
    }
  },
  computed: {
    ...mapState({
      stores: 'restaurants'
    })
  },
  watch: {
    async time () {
      await this.getProjects()
    },
    async store () {
      await this.getProjects()
    },
    async partner () {
      await this.getProjects()
    }
  },
  async mounted () {
    await this.getProjects()
  },
  methods: {
    async getProjects () {
      const params = { time: this.time }
      if (this.store) params.store = this.store
      if (this.partner) params.partner = this.partner
      const data = (await getapi('projects?' + new URLSearchParams(params))) || []
      this.projects = data.data
      this.partners = data.partners
      this.addnew = false
    }
  }

}
</script>

<style lang="scss" scoped>
.cubeProjects {
  padding: 36px 32px;
  display: flex;
  align-items: flex-start;
  justify-content: flex-start;
  gap: 20px;
}
</style>
